import { render } from "./ProjectPageView.vue?vue&type=template&id=402de84c&scoped=true"
import script from "./ProjectPageView.vue?vue&type=script&lang=js"
export * from "./ProjectPageView.vue?vue&type=script&lang=js"

import "./ProjectPageView.vue?vue&type=style&index=0&id=402de84c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402de84c"]])

export default __exports__